/* eslint-env node */
// Workaround: date-fns v4's format.cjs has no default export,
// which breaks `import format from 'date-fns/format'` after Babel transpilation.
// This shim re-exports the named `format` as module.exports so _interopRequireDefault works.
var m = require('date-fns-format-impl');
module.exports = m.format;
